import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {Subject} from 'rxjs';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {BookingPrice} from '../../../../classes/BookingPrice';
import {OrderType} from '../../../../enums/OrderType';
import {Currency} from '../../../../enums/Currency';
import {TimePeriodService} from '../../../../services/time-period.service';
import {Office} from '../../../../classes/Office';
import {OfficeService} from '../../../../services/office.service';
import {RoomService} from '../../../../services/room.service';
import {Room} from '../../../../classes/Room';
import {BookingOption} from '../../../../enums/BookingOption';

@Component({
  selector: 'app-booking-price-edit',
  styleUrls: ['./booking-price-edit.component.scss'],
  templateUrl: './booking-price-edit.component.html',
  encapsulation: ViewEncapsulation.None
})
export class BookingPriceEditComponent implements OnInit {

  @Input() bookingPrice: BookingPrice;

  destroy = new Subject<any>();
  currentDialog = null;
  errorMessage: string;
  currencies = [];
  timePeriods = [];
  bookingOptions = [];

  offices: Office[];
  rooms: Room[];

  public bookingPriceForm: FormGroup;

  constructor(private activeModal: NgbActiveModal,
              private formBuilder: FormBuilder,
              private timePeriodService: TimePeriodService,
              private officeService: OfficeService,
              private roomService: RoomService) {}

  ngOnInit(): void {
    this.currencies = Object.keys(Currency);
    this.bookingOptions = Object.keys(BookingOption);

    this.timePeriodService.getAll().subscribe({
      next: (timePeriods) => {
        this.timePeriods = timePeriods;
      },
      error: (error) => this.errorMessage = error.error.error
    });

    this.officeService.getAll().subscribe({
      next: (response: Office[]) => this.offices = response,
      error: err => console.log(err.error) // TODO handle error
    });

    this.roomService.getAll().subscribe({
      next: (response: Room[]) => this.rooms = response,
      error: err => console.log(err.error) // TODO handle error
    });


    if (this.bookingPrice) {
      this.bookingPriceForm = this.formBuilder.group({
        id: [this.bookingPrice.id],
        officeId: [this.bookingPrice.officeId, Validators.required],
        roomId: [this.bookingPrice.roomId, Validators.required],
        bookingOption: [this.bookingPrice.bookingOption, Validators.required],
        price: [this.bookingPrice.price, Validators.required],
        currency: [this.bookingPrice.currency, Validators.required],
        timePeriodId: [this.bookingPrice.timePeriodId, Validators.required]
      });
    } else {
      this.bookingPriceForm = this.formBuilder.group({
        id: [''],
        officeId: [null, Validators.required],
        roomId: [null, Validators.required],
        bookingOption: ['', Validators.required],
        price: ['', Validators.required],
        currency: [Currency.NIS, Validators.required],
        timePeriodId: [null, Validators.required]
      });
    }
  }

  closeModal(sendData): void {
    this.activeModal.close(sendData);
  }
}
